import { useEffect, useRef } from 'react';
import { useQuest, type Settings } from '../lib/store.tsx';

const ROWS: { key: keyof Settings; label: string; help: string }[] = [
  { key: 'sound', label: 'Sound', help: 'Off by default' },
  { key: 'accessible', label: 'Assist mode', help: 'Press and hold BUILD instead of tapping (slower, steady rate). Same reward; assist runs don’t rank on the leaderboard.' },
  { key: 'reducedMotion', label: 'Reduce motion', help: 'Fewer particles and animations' },
  { key: 'highContrast', label: 'High contrast', help: 'Brighter labels and borders' },
  { key: 'haptics', label: 'Vibration', help: 'Where supported' },
];

export function SettingsSheet({ onClose }: { onClose: () => void }) {
  const { settings, setSettings } = useQuest();
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.querySelector('input')?.focus();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="overlay" role="dialog" aria-modal="true" aria-labelledby="settings-title" onClick={onClose}>
      <div className="card" ref={ref} onClick={(e) => e.stopPropagation()}>
        <p className="eyebrow">Settings</p>
        <h2 className="h2" id="settings-title">Play your way</h2>
        <div>
          {ROWS.map((r) => (
            <label key={r.key} className="toggle-row">
              <span>
                {r.label}
                <br />
                <small className="muted">{r.help}</small>
              </span>
              <input type="checkbox" className="switch" checked={settings[r.key]} onChange={(e) => setSettings({ [r.key]: e.target.checked })} />
            </label>
          ))}
        </div>
        <button className="btn primary block" onClick={onClose}>
          Done
        </button>
      </div>
    </div>
  );
}
